export default __webpack_public_path__ + "static/media/error.af19331d.svg";